export default __webpack_public_path__ + "eac01f040c320ecf83070ba018687a80.png";